import { ReactElement, useEffect } from 'react'
import { Container, Col, Row } from 'react-bootstrap'
import useBreakpoint from 'use-breakpoint'
import { LiveWrapper, Space } from './subcomponents'
import CompletedSessions from './CompletedSessions'
import UpComingSessions from './UpComingSessions'
import LiveSessions from './LiveSessions'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../redux/store'
import BREAKPOINTS from '../../../const/breakpoint'
import { getCompletedSessions, getSessions } from '../../../redux/live/action'

const Live = (): ReactElement => {
  const {
    batchList = [],
    branchList = [],
    coachingCentreId = ''
  } = useSelector(
    (state: RootState) => ({
      batchList: state.user?.userInfo?.userDetail?.batchList,
      branchList: state.user?.userInfo?.userDetail?.branchList,
      coachingCentreId: state.user?.userInfo?.userDetail?.coachingCentre?.id
    }),
    shallowEqual
  )

  const dispatch = useDispatch()
  const { breakpoint } = useBreakpoint(BREAKPOINTS)
  const batchIds = batchList.map((batch) => batch.id)
  const branchIds = branchList.map((branch) => branch.id)
  const requestDate = {
    batchIds,
    branchIds,
    coachingCentreId
  }

  useEffect(() => {
    dispatch(getCompletedSessions(requestDate))
    dispatch(getSessions({ ...requestDate, sessionTense: 'UPCOMING' }))
    dispatch(getSessions({ ...requestDate, sessionTense: 'LIVE' }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <LiveWrapper id="container">
      <Container fluid>
        <>
          <Row>
            <Col sm={12}>
              <LiveSessions />
            </Col>
          </Row>
          <Space />
          <Row>
            <Col sm={12} md={6}>
              <CompletedSessions />
            </Col>
            {breakpoint === 'mobile' && <Space />}
            <Col sm={12} md={6}>
              <UpComingSessions />
            </Col>
          </Row>
        </>
      </Container>
    </LiveWrapper>
  )
}

export default Live
